import type {ReactNode} from 'react';
import {useSearchParams} from 'react-router-dom';
import {withNodeSearchParam} from 'src/app/tree-browser/treeBrowserUtils';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import {ComplianceStandardTreeBrowser} from './ComplianceStandardTreeBrowser';
import {complianceTreeRootId} from './complianceStandardTreeState';
import {useAppNavigate} from 'src/shared/hooks/useAppNavigate';

export interface ComplianceStandardsBrowserShellProps {
  variant: 'company' | 'regulatory';
  /** Tree node id of the standard the page is showing; undefined until the record loads. */
  selectedId?: string;
  activeOnly?: boolean;
  children: ReactNode;
}

/** Standard hierarchy pane plus node-select navigation, for every Compliance route. */
export const ComplianceStandardsBrowserShell = ({
  variant,
  selectedId,
  activeOnly,
  children,
}: ComplianceStandardsBrowserShellProps) => {
  const navigate = useAppNavigate();
  const [searchParams] = useSearchParams();

  const handleSelect = (nodeId: string) => {
    const next = withNodeSearchParam(
      searchParams,
      nodeId,
      complianceTreeRootId
    );
    navigate({
      pathname: PathUtility.InstanceComplianceStandards(variant),
      search: next.toString(),
    });
  };

  return (
    <ComplianceStandardTreeBrowser
      variant={variant}
      selectedId={selectedId}
      onSelect={handleSelect}
      activeOnly={activeOnly}>
      {children}
    </ComplianceStandardTreeBrowser>
  );
};
